import { createGlobalStyle, keyframes } from 'styled-components';
import { tutorialCssConstants } from './util/cssConstants';

const pulse = keyframes`
   0% {
      transform: scale(1);
   }
   50% {
     transform: scale(var(--pulse-animation-scale));
   }
   100% {
      transform: scale(1);
   }
`;

const pulseB = keyframes`
   0% {
      transform: scale(1);
   }
   50% {
     transform: scale(var(--pulse-animation-scale-b));
   }
   100% {
      transform: scale(1);
   }
`;

const GlobalStyles = createGlobalStyle`
   .hidden {
      display: none !important;
   }

   .highlighted {
      box-shadow: 0px 0px 0px 4px var(--brand-light-orange);
      animation: 1s ${pulse} ease-out infinite;
   }

   .highlighted-once {
      box-shadow: 0px 0px 0px 4px var(--brand-light-orange);
      animation: 1s ${pulse} ease-out;
   }

   .highlighted-once-b {
      box-shadow: 0px 0px 0px 4px var(--brand-light-orange);
      animation: 1s ${pulseB} ease-out;
   }

   .highlighted-still {
      box-shadow: 0px 0px 0px 4px var(--brand-light-orange);
   }

   .keyboard-key.highlighted-still {
      box-shadow: 0px 0px 0px 4px inset var(--brand-light-orange);
   }

   :root {
      --header-inner-height: 50px;
      --header-margin: 10px;
      --header-height: 70px;
      --exercise-bottom-padding: 10px;

      --tutorial-height: ${tutorialCssConstants.initialHeightLandscape}px;
      --tutorial-padding: 10px;
      --tutorial-padding-left: calc(var(--tutorial-padding) + var(--safe-area-inset-left));
      --tutorial-padding-right: calc(var(--tutorial-padding) + var(--safe-area-inset-right));
      --tutorial-padding-bottom: max(var(--tutorial-padding), var(--safe-area-inset-bottom));

      @media (min-height: 500px) {
         --tutorial-height: ${tutorialCssConstants.initialHeightPortrait}px;
      }

      --modal-margin: 1em;
      --modal-padding: 30px;
      --modal-content-width: min(calc(var(--safe-width) - 2 * (var(--modal-margin) + var(--modal-padding))), 300px);

      @media (min-height: 500px) and (min-width: 500px) {
         --modal-padding: 45px;
      }

      --below-interface-height: 0px;


   }
`;

export { GlobalStyles };
